import { formatUrl, route } from './route';

export const authRoutes = {
    login: (params?: URLSearchParams) => formatUrl(route('/(auth)/(login-flow)/login'), params),
    changePassword: () => route('/(auth)/(login-flow)/changepassword'),
    register: () => route('/(auth)/register'),
    forgotPassword: () => route('/(auth)/forgotpassword'),
    contact: () => route('/(auth)/contact')
};
